import { motion } from "framer-motion";

const STATS = [
  { value: "10+", l1: "YEARS OF REAL", l2: "AGENCY EXPERIENCE" },
  { value: "LIVE", l1: "REAL CLIENT", l2: "PROJECTS" },
  { value: "15", l1: "SEATS PER", l2: "COHORT" },
  { value: "100%", l1: "PLACEMENT", l2: "ASSISTANCE" },
  { value: "PRO", l1: "INDUSTRY-STANDARD", l2: "TOOLS" },
];

export default function Differentiators() {
  return (
    <section className="bg-lima-cream border-b border-black/10" data-testid="differentiators-section">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {STATS.map((s, i) => (
          <motion.div
            key={s.value}
            initial={{ opacity: 0, y: 24, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center gap-4 px-6 md:px-8 py-7 md:py-9 border-b lg:border-b-0 border-r border-black/10 last:border-r-0 [&:nth-child(2n)]:border-r-0 md:[&:nth-child(2n)]:border-r lg:[&:nth-child(2n)]:border-r"
            data-testid={`differentiator-${i}`}
          >
            <span className="font-serifd text-3xl md:text-4xl text-lima-blue leading-none whitespace-nowrap">{s.value}</span>
            <span className="font-mono2 text-[11px] md:text-xs tracking-[0.12em] text-black/60 leading-relaxed">
              {s.l1}
              <br />
              {s.l2}
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
